<template>
  <add-image  v-if="imageForActions === '' && imageResult === ''">
    <div style="text-align: center; margin-bottom: 12px; color: var(--secondary-100);">{{ $t('menu.watermarks') }}</div>
    <img :src="`${baseUrl}/images/multi-menu/watermarks.png`" alt="">
  </add-image>
  <div
    class="service__container watremarks"
    :class="{ 'service__container--mobile': isMobile }"
    v-else-if="imageForActions !== '' && imageResult === ''"
  >
    <div class="watremarks-edit__workarea">
      <image-finetune
        class="watermarks-edit__finetune"
        v-if="isEdit"
        :src="imageForActions"
        @reset="isEdit = false"
        @save="editHandler"
        :actions="['reset', 'save']"
      />
      <template v-else>
      <ai-card :radius="16" class="watremarks-edit__workarea__card">
        <div class="watremarks-edit__workarea__container">
          <v-img :src="imageForActions" class="watremarks-edit__workarea__image" />
          <ai-drop-loader v-if="generationLoading" />
        </div>
        <div class="watremarks-edit__workarea__data">
          <!-- <div class="watremarks-edit__workarea__data__info">
            {{ imageWidth }} × {{ imageHeight }}px | {{ (imageSize / 1024).toFixed(2) }} kb
          </div> -->
          <v-spacer />
          <div class="watremarks-edit__workarea__actions">
            <ai-button theme="dark" @click="imageForActions = ''">{{ $t('services.reset') }}</ai-button>
            <ai-button
              v-if="!isMobile"
              :disabled="generationLoading"
              theme="gradient-primary"
              class="watremarks-edit__workarea__button"
              @click="removeBackgroundFileHandler"
            >
              <template v-if="!generationLoading">
                {{ $t('watremarks.watremarks') }}
              </template>
              <time-counter v-else />
            </ai-button>
          </div>
        </div>
        <ai-button
          v-if="isMobile"
          theme="gradient-primary"
          :disabled="generationLoading"
          @click="removeBackgroundFileHandler"
          class="watremarks-edit__settings__button"
        >
          <template v-if="!generationLoading">
            {{ $t('watremarks.watremarks') }}
          </template>
          <time-counter v-else />
        </ai-button>
      </ai-card>
      </template>
    </div>
  </div>
  <result-image v-else-if="imageForActions !== '' && imageResult !== ''" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useEventBus } from '@vueuse/core';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services/index';

// import { getBase64Size } from '@/helpers/getBase64Size';
import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';

const busError = useEventBus<string>('toast-error');

const { t } = useI18n();
const baseUrl = process.env.VUE_APP_BASE_URL;

const { isMobile } = storeToRefs(useCommonStore());

const { generateImage } = useServicesStore();

const { imageForActions, imageResult, imagePrev } = storeToRefs(useServicesStore());

const generationLoading = ref<boolean>(false);
const imageWidth = ref<number>(0);
const imageHeight = ref<number>(0);
const isEdit = ref<boolean>(false);

// const imageSize = computed(() => getBase64Size(imageForActions.value));

const removeBackgroundFileHandler = (): void => {
  generationLoading.value = true;
  generateImage({
    action: 'watermarks',
    image: removeBase64Prefix(imageForActions.value),
    params: {},
  })
    .then((res) => {
      imagePrev.value = imageForActions.value;
      imageResult.value = `data:image/png;base64,${res.image}`;
    })
    .catch((e) => {
      busError.emit(e?.error || t('common.err-gen'));
    })
    .finally(() => {
      generationLoading.value = false;
    });
};

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
    };
    img.src = imageForActions.value;
  }
};

const editHandler = (image: string): void => {
  imageForActions.value = image;
  isEdit.value = false;
};

onMounted(() => {
  imageSizeHandler();
});
</script>

<style scoped lang="scss" src="./Watermarks.scss" />
